<mat-sidenav-container fullscreen>
  <mat-sidenav
    #sidenav
    mode="side"
    class="example-sidenav"
    [ngStyle]="{ 'width.em': sidenavWidth }"
    [opened]="_authService.isOpen$ | async">
    <rental-sidebar></rental-sidebar>
  </mat-sidenav>
  <div class="example-sidenav-content">
    <div class="top_header">
      <div class="toggle" (click)="toggleSidenav()">
        <div>
          <span></span>
          <span></span>
          <span></span>
        </div>
        <div class="heading">
          @if (headingData.heading === 'Welcome Back') {
            {{ 'WelcomeBack' | translate: { name: profile && profile.firstName ? profile.firstName : '' } }}
          } @else {
            {{ headingData.heading | translate }}
          }

          @if (
            headingData.heading === 'Service Catalogue' 
          ) {
            <div
              [ngStyle]="{
                right:
                  headingData.heading === 'Service Catalogue'
                    ? '14px'
                    : '-45px',
              }"
              class="pending upcoming">
              {{ 'Upcoming' | translate }}
            </div>
          }
          <p>
            {{
              headingData.description === 'date'
                ? (today | date: 'EEEE MMMM d, y')
                : ( headingData.description | translate )
            }}
          </p>
        </div>
      </div>

      <div class="top_header_ryt">
        <figure class="ntf_bell ntf_mobile">
          <span class="esq-icon-notify-icon notify-icn"></span>
        </figure>
        <figure
          class="ntf_bell demo-section"
          matBadge="4"
          matBadgeOverlap="false"
          (menuOpened)="fetchPanelNotifications()"
          [matMenuTriggerFor]="menu1">
          <span class="esq-icon-notify-icon notify-icn"></span>
        </figure>
        <mat-menu
          #menu1="matMenu"
          xPosition="before"
          yPosition="below"
          class="noti_dropBox_global">
          <h2>{{ 'Notifications' | translate }}</h2>
          <div class="noti_scroll" [ngClass]="{
              'empty-data': notifications && !notifications.length,
            }">
            <ul class="not_list">
            @for (
              item of notifications && notifications.slice(0, 5);
              track $index
            ) {
              <li class="ntf-list">
                <div class="bullet-icn">
                  •
                  <div (click)="handleRedirection(item)"
                      class="ntf_dt pointer"
                      >
                    <h3>{{ item.title }}</h3>
                    <p>{{ item.message }}</p>
                  </div>
                </div>
                <p class="ntf_tym">
                  {{ item['createdAt'] | day_diff }}
                </p>
              </li>
            } @empty {
              {{ 'NoDataFound' | translate }}
            }
            </ul>
            </div>
            <div class="see_link_wrapper">
              <span class="see_link" routerLink="/received-notification">
                {{ 'View All Notifications' | translate }}
              </span>
            </div>
        </mat-menu>

        <div>
          <figure class="esq-gap-5" mat-button [matMenuTriggerFor]="menu">
            <img
              [src]="
                profile && profile.image ? profile.image : assetsConst.adminIcon
              "
              alt="user" />
            <figure>
              <img class="account-drop-down" [src]="assetsConst.left_arrow" alt="" />
            </figure>
          </figure>
          <mat-menu
            #menu="matMenu"
            class="dropbox"
            xPosition="before"
            yPosition="below">
            <ul>
              <li routerLink="/profile">
                <span class="esq-icon-log-out-icn fs-18"></span>
                {{ 'myProfile' | translate }}
              </li>
              <li routerLink="/change-password">
                <span class="esq-icon-chng-pswd-icn fs-18"></span>
                {{ 'changePassword' | translate }}
              </li>
              <li (click)="logout()">
                <span class="esq-icon-profile-icon fs-18"></span>
                {{ 'Logout' | translate }}
              </li>
            </ul>
          </mat-menu>
        </div>
      </div>
    </div>
    <div class="main_wrapper">
      <router-outlet />
    </div>
    <mat-menu #menu="matMenu"> </mat-menu>
  </div>
</mat-sidenav-container>
